import { defineMessages } from 'react-intl';

const messages = defineMessages({
  FilterLinkTypeReverse: 'Link type (reverse)',
  LinkTypeReverse: 'Link type (reverse)',
  ExportToExcelStarted: 'Export to excel started',
  TaskScheduleOverview: 'Task schedule overview',
  SelectOverviewColumns: 'Select overview columns',
  CountRelationsSelected: 'Selected {count} / {total} relations',
  EndFiscalYear: 'End fiscal year',
  NextAnnualMeeting: 'Next annual meeting',
  WithoutSchedule: 'Without schedule',
  Relation: 'Relation',
  Search: 'Search',
  ColumnConfig: 'Configure columns',
  OpenInTaskboard: 'Open this task in the task board',
  OpenTaskOverview: 'Open task overview',
  SetTaskSchedulingQueued:
    'Task schedules for the selected relations will be added shortly. Click here to view its progress.',
  DeleteTaskScheduleQueued: 'The task schedules will be deleted shortly.',
  ResetFilters: 'Reset filters',
  ExportToExcel: 'Export to Excel',
  ExportTaskSchedules: 'Export task schedules',
  ExportAuthorizations: 'Export authorizations',
  AssignedToMe: 'Assigned to me',
  Unassigned: 'Unassigned',
  NoTasksFound: 'No tasks found',
  SelectAll: 'Select all',
  RelationLabels: 'Relation labels',
  WithoutRelationLabels: 'Without relation labels',
  Assignment: 'Assignment',
  DefaultAssignment: 'Default assignment',
  FilterLinkType: 'Filter on link type',
  LinkType: 'Link type',
  VatPeriodicity: 'Vat periodicity',
  EmptyVATPeriodicity: 'Empty vat periodicity',
  EndFirstFiscalYear: 'End first fiscal year',
  WithoutEndFirstFiscalYear: 'Without end first fiscal year',
  WithEndFirstFiscalYear: 'With end first fiscal year',
  RecalculateTaskDeadlinesTitle: 'Recalculate task deadlines?',
  RecalculateTaskDeadlinesMsg:
    'There are {count} tasks with a deadline based on the general meeting or end fiscal year. Do you want to recalculate the deadline of these tasks?',
  WithoutEndFiscalYear: 'Without end fiscal year',
  WithEndFiscalYear: 'With end fiscal year',
  RelationGroups: 'Relation groups',
  SelectYourFilters: 'Select your filters',
  MoreFilters: 'More filters',
});

export default messages;
